<nb-card style="height: 100%;">
    <nb-card-header style="padding: 5px; margin-left: 10px;">
        Tasks Completed
        <br> By Month
    </nb-card-header>
    <nb-card-body [nbSpinner]="isLoading">
        <div style="width: 100%;">
            <canvas baseChart #baseChart="base-chart" 
                    [datasets]="chartData" 
                    [labels]="chartLabels" 
                    [options]="chartOptions"   
                    [legend]="chartLegend" 
                    [type]="chartType"
                    (chartHover)="chartHovered($event)" 
                    (chartClick)="chartClicked($event)">
                    <!-- TODO Upgrade [colors]="myColors" -->

            </canvas>
            <button mat-button>Update</button>

        </div>
        <!-- <div>
                <button mat-button (click)="randomize()">Update</button>
            </div> -->
    </nb-card-body>
</nb-card>